export const USER_MODALS_ALLOWED_NAMES = [
  'login',
  'limited-login',
  'forgot-password',
  'social-forgot-password',
  'change-password',
  'registration',
  'registration-lp',
  'registration-confirmation',
  're-registration-confirmation',
  'social-re-registration-confirmation',
  'registration-activation',
];
